import { render, staticRenderFns } from "./OneNewsEdit.vue?vue&type=template&id=1d7f399e&scoped=true&"
import script from "./OneNewsEdit.vue?vue&type=script&lang=js&"
export * from "./OneNewsEdit.vue?vue&type=script&lang=js&"
import style0 from "./OneNewsEdit.vue?vue&type=style&index=0&id=1d7f399e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f399e",
  null
  
)

export default component.exports